<template>
  <div class="content">
    <h1>Mailing List</h1>
    <div class="text-center px-4" v-html="compiledMarkdown" />
  </div>
</template>


<script>
import marked from 'marked';
export default {
  computed: {
    compiledMarkdown: function () {
      return marked(this.$root.$data.images.mailing)
    }
  },  
  head: {
    title() {
      return {
        inner: "Thanks - Mailing List"
      }
    },
  }
}
</script>

<style>

</style>